<template>
  <ContainerScrolling class="LegalInformation">
    <LayoutFill :no-gutters="!bannerGutter" :no-padding="!bannerGutter">
      <MainBanner :title="pageTitle" :solid-header="solidHeader" />
    </LayoutFill>
    <LayoutGutters>
      <SubNavigationTabs
        id="legalInformation"
        v-slot="{ activeTab }"
        :page-title="pageTitle"
        :page-mapping="pageMapping"
        :centered-tabs="centeredTabs"
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :id="`tab-${index}`"
          :key="index"
          :aria-controls="`panel-${index}`"
          :tabindex="activeTab !== index ? -1 : 0"
        >
          {{ tab.title }}
        </v-tab>
        <v-tab-item v-for="(tab, index) in tabs" :key="index">
          <v-card flat>
            <div
              :id="`panel-${index}`"
              role="tabpanel"
              :aria-labelledby="`tab-${index}`"
              :hidden="activeTab !== index"
            >
              <LegalTerms :term="tab.term" />
            </div>
          </v-card>
        </v-tab-item>
      </SubNavigationTabs>
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";
import SubNavigationTabs from "~/components/navigation/SubNavigationTabs";

import MainBanner from "~/components/banner/MainBanner";
import LegalTerms from "~/components/page/components/terms/LegalTerms";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "LegalInformation",
  components: {
    LegalTerms,
    ContainerScrolling,
    LayoutGutters,
    LayoutFill,
    MainBanner,
    SubNavigationTabs,
  },
  middleware: ["ensureUserLoaded"],
  data() {
    return {
      pageTitle: "Legal Notices",
    };
  },
  head() {
    const { siteName } = this;

    const title = getPageTitle(siteName);
    const pageTitle = "Legal Information | " + title;
    const cupTechText =
      this.partner === "chemrxiv"
        ? "technology provided by"
        : "brought to you by";

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `Legal notices, including Terms of Submission and Terms of Use for ${siteName}, ${cupTechText} Cambridge University Press.`,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      siteName: (state) => getSiteName(state.theme),
      layout: (state) => state.theme.layout,
      terms: (state) => state.theme.terms,
      tabs: (state) => state.theme.pages.legal,
      pageMapping: (state) => state.theme.pages.legal.map((tab) => tab.pageMap),
    }),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    bannerGutter() {
      return this.layout.staticBannerGuttering;
    },
    centeredTabs() {
      return this.layout.infoPageTabsCentered;
    },
  },
  watchQuery: ["show"],
};
</script>
